export interface Material {
  id: number;
  name: string;
  description?: string;
  parentMaterialId?: number | null;
  points?: number;
  sortOrder?: number;
}

export interface Item {
  id: number;
  material: number;
  name: string;
  description: string;
  adminApproved?: number;
  type: ItemType;
}

export enum ItemType {
  Recycle = 'recycle',
  Reuse = 'reuse',
}

export interface Session {
  id: string;
}

export enum DepositStatus {
  PendingReview = 1,
  Approved = 2,
  Rejected = 3,
  Duplicate = 4,
}

export interface CreateDepositDto {
  material: number;
  item: number;
}

export interface Deposit {
  id: number;
  material: number;
  item: number;
  imageUrl: string;
  depositStatus?: DepositStatus;
  createdAt?: string;
  updatedAt?: string;
  adminNotes?: string;
  session?: string;
  dirty?: number;
  fraud?: number;
  multiObject?: number;
  noObject?: number;
  annotatorId?: string;
  brand?: string;
  product?: string;
  product_size?: string;
  product_flavor?: string;
  binCategories?: BinCategory[];
  points?: number;
  itemName?: string;
}

export interface AnnotatorDeposit extends Deposit {
  date: string;
  userId: string;
  itemName?: string;
  itemMaterialId?: number;
  catalogMaterialId?: number;
}

export interface PaginatedAnnotatorDeposits {
  data: AnnotatorDeposit[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface BinCategory {
  id: number;
  color: string;
  contrastColor: string;
  title: string;
  orgId: number;
}

export interface RecyclingRuleBinCategory {
  id: number;
  title: string;
  color: string;
  allowedItems: string[];
  allowedMaterialIds?: number[];
  itemExceptions?: {
    id: number;
    itemId: number;
    itemName: string;
    ruleType: 'include' | 'exclude';
  }[];
}

export interface RecyclingRules {
  orgId: number;
  orgName: string;
  bins: RecyclingRuleBinCategory[];
}

export interface OrganizationLookup {
  id: number;
  name: string;
  abbr?: string;
  imageUrl?: string;
}

export interface BinGuidelineExceptionDto {
  id: number;
  itemId: number;
  itemName: string;
  ruleType: 'include' | 'exclude';
}

export interface BinGuidelineDto {
  id: number;
  title: string;
  color: string;
  contrastColor: string;
  materialIds: number[];
  exceptions: BinGuidelineExceptionDto[];
}

export interface OrgBinGuidelinesDto {
  orgId: number;
  orgName: string;
  bins: BinGuidelineDto[];
}

export interface SubMaterialDto {
  id: number;
  name: string;
  description: string;
  points: number;
  sortOrder: number;
}

export interface ParentMaterialCatalogDto {
  id: number;
  name: string;
  description: string;
  points: number;
  sortOrder: number;
  children: SubMaterialDto[];
}

export interface MaterialsCatalogDto {
  materials: ParentMaterialCatalogDto[];
}

export interface OrgAdminAssignmentDto {
  adminEmail: string;
  orgId: number;
  orgName: string;
  isActive: boolean;
}

export interface OrgAdminsListDto {
  assignments: OrgAdminAssignmentDto[];
}

export interface AnnotatorAccessDto {
  annotatorEmail: string;
  isActive: boolean;
}

export interface AnnotatorsListDto {
  annotators: AnnotatorAccessDto[];
}

export interface PointsBalance {
  currentPoints: number;
  pendingPoints: number;
}

export interface AnnotatorVerdict {
  status: DepositStatus;
  material?: number;
  item?: number;
  adminNotes?: string;
  dirty?: number;
  fraud?: number;
  noObject?: number;
  brand?: string;
  product?: string;
  product_size?: string;
  product_flavor?: string;
  multiObject?: number;
}
